import React from 'react';
import styles from './TableFilter.module.css';
import Tooltip from '../../../Atoms/Tooltip/Tooltip';
import filter from '../../../../assets/Imagess/filter.svg';
import closeIcon from '../../../../assets/Imagess/SettingsSideBar/exitBurgerSettingsIco.svg';
import { useTableFilterValuesContext } from '../../../../Context/TableFilterValues';
const TableFilter = ({
  isFilter,
  setIsFilter,
  setFilterByField,
  setFilteredColumn = null,
}) => {
  const { filterValues, setFilterValues, filterColumns, setFilterColumns } =
    useTableFilterValuesContext();

  return (
    <div className={`${styles['filterIcon']}`}>
      <Tooltip content='Filter'>
        <img
          src={isFilter ? closeIcon : filter}
          alt='filter'
          onClick={() => (
            setIsFilter(!isFilter),
            setFilterByField({
              filterByField: '',
              filterBy: '',
            }),
            setFilteredColumn != null
              ? (setFilterColumns([]),
                setFilterValues({}),
                setFilteredColumn([]))
              : null
          )}
        />
      </Tooltip>
    </div>
  );
};

export default TableFilter;
